"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = __importDefault(require("date-fns/format"));
const de_1 = __importDefault(require("date-fns/locale/de"));
const fr_1 = __importDefault(require("date-fns/locale/fr"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const libs_language_1 = require("@hotelplan/libs.language");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
// HACK: french month's locale already includes dot for some reason
const TRAVEL_INFORMATION_DATE_FORMAT_DE = 'EEEEEE, d. MMM.';
const TRAVEL_INFORMATION_DATE_FORMAT_FR = 'EEEEEE, d. MMM';
const formatDateToTravelInformationFormat = (date, language) => (0, format_1.default)(date, language === 'fr'
    ? TRAVEL_INFORMATION_DATE_FORMAT_FR
    : TRAVEL_INFORMATION_DATE_FORMAT_DE, {
    locale: language === 'fr' ? fr_1.default : de_1.default,
});
const TravelDatesInformationWrapper = styled_components_1.default.p((0, util_theme_sxc_1.sx2CssThemeFn)({
    textAlign: 'center',
    fontSize: [1, 2],
    color: [null, 'secondary'],
    p: [3, '9px'],
}));
const TravelDatesInformation = ({ departureDate, returnDate, duration, onlyDates, onlyDepartureDate, onlyReturnDate, language = libs_language_1.languageDefault, }) => {
    const SEPARATOR = '- ';
    return (react_1.default.createElement(TravelDatesInformationWrapper, { className: "travel-dates-information" },
        !onlyReturnDate && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { "data-id": "travelDatesInformationDepartureDate" }, formatDateToTravelInformationFormat(departureDate, language)),
            ' ')),
        !onlyDepartureDate && !onlyReturnDate ? react_1.default.createElement(react_1.default.Fragment, null, SEPARATOR) : null,
        !onlyDepartureDate && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { "data-id": "travelDatesInformationReturnDate" }, returnDate
                ? formatDateToTravelInformationFormat(returnDate, language)
                : '...'),
            ' ',
            !onlyDates && (react_1.default.createElement(react_1.default.Fragment, null,
                "/ ",
                react_1.default.createElement("span", { "data-id": "travelDatesInformationDuration" }, duration)))))));
};
exports.default = TravelDatesInformation;
//# sourceMappingURL=TravelDatesInformation.js.map